<template>
  <footer class="footer">
    <div class="footer-section">
      <div class="wrapper">
        <div class="column first">
          <router-link to="/" class="logo flex">
            <img src="./../img/logo.svg" class="img" />
            <div class="title">IdeasGen</div>
          </router-link>
          <div class="desc small">
            {{ $t(`IdeasGen is Unleashing
            Creativity, Enhancing Conversations.
            Your Source for Diverse AI Prompts.`) }}
          </div>
          <ul class="nav social-nav">
            <li v-for="link in socialLinks" :key="link.image" class="nav__item nav__item-text-pages">
              <a :href="link.url" class="desc" target="_blank">
                <img :src="link.image" :alt="link.url" class="img" />
              </a>
            </li>
          </ul>
          <div class="desc extrasmall semibold">{{ settings.copyright }}</div>
        </div>
        <div class="column second">
          <div class="nav first">
            <div class="nav__item">
              <router-link to="/" class="desc small semibold">{{ $t(`Home`) }}</router-link>
            </div>
            <div class="nav__item">
              <router-link to="/product-list" class="desc small semibold">{{ $t(`Prompts`) }}</router-link>
            </div>
            <div class="nav__item">
              <div @click="scrollToSection('howItWorks')" class="desc small semibold hover-link">{{ $t(`How it works`) }}</div>
            </div>
            <div class="nav__item">
              <div @click="scrollToSection('features')" class="desc small semibold hover-link">{{ $t(`Features`) }}</div>
            </div>
            <div class="nav__item">
              <div @click="scrollToSection('cases')" class="desc small semibold hover-link">{{ $t(`Cases`) }}</div>
            </div>
          </div>
        </div>
        <div class="column third">
          <ul class="nav" v-if="textPageList.length">
            <template :key="item.id" v-for="item in textPageList">
              <li class="nav__item nav__item-text-pages">
                <a class="desc small semibold" @click="goToPage(item.id)">
                  {{ item.title }}
                </a>
              </li>
            </template>
          </ul>
        </div>
        <div class="column fourth">
          <div class="text">
            <div class="item">
              <div class="desc small semibold">{{ $t(`Email`) }}</div>
              <div class="desc extrasmall">{{ settings.support_email }}</div>
            </div>
            <div class="item">
              <div class="desc small semibold">{{ $t(`Address`) }}</div>
              <div class="desc extrasmall">{{ settings.company_address }}</div>
            </div>
            <div class="item">
              <div class="desc small semibold">{{ $t(`Company name`) }}</div>
              <div class="desc extrasmall">{{ settings.company_name }}</div>
            </div>
            <div class="item">
              <div class="desc small semibold">{{ $t(`Reg number`) }}</div>
              <div class="desc extrasmall">{{ settings.company_reg_number }}</div>
            </div>
          </div>
          <ul class="payment-methods-list">
              <li v-for="image in footerImages" :key="image" class="image-wrapper">
                <img :src="image" class="support-icon img" />
              </li>
            </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  inject: ['settings', 'textPageList', 'goToPage', 'allPaymentMethods', 'socialLinks'],
  emits: ['scrollToSection'],
  name: 'Footer',
  props: [],

  data: function () {
    return {
    }
  },

  computed: {
    paymentMethodsList() {
      if (!this.allPaymentMethods) return [];
      return this.allPaymentMethods;
    },
    allImages() {
      return this.paymentMethodsList.flatMap(this.getImages);
    },
    footerImages() {
      return this.settings.footer_images || [];
    },
  },

  methods: {
    getImages(method) {
      const images = [];
      if (method.code === 'card' && method.title === 'Visa/Mastercard') {
        images.push(require('@/img/visa.svg'), require('@/img/mc_symbol.svg'));
        // images.push(require('@/img/3ds.png'));
      } else if (method.code === 'eps' || method.title === 'EPS') {
        images.push(require('@/img/eps.svg'));
      } else if (method.code === 'trustly' || method.title === 'Trustly') {
        images.push(require('@/img/trustly.svg'));
      } else if (method.code === 'giropay' || method.title === 'GiroPay') {
        images.push(require('@/img/giropay.svg'));
      } else if (method.code === 'blik' || method.title === 'Blik') {
        images.push(require('@/img/blik.svg'));
      } else if (method.code === 'paidby' || method.title === 'Paidby') {
        images.push(require('@/img/paidby.svg'));
      } else if (method.code === 'klarna' || method.title === 'Klarna') {
        images.push(require('@/img/klarna.svg'));
      } else if (method.code === 'sofortuberweisung' || method.title === 'Sofortuberweisung') {
        images.push(require('@/img/sofortuber.svg'));
      } else if (method.code === 'ideal' || method.title === 'iDEAL') {
        images.push(require('@/img/ideal.svg'));
      } else if (method.code === 'bancontact' || method.title === 'Bancontact') {
        images.push(require('@/img/bancontact.svg'));
      }
      return images;
    },
    scrollToSection(section) {
      this.$emit('scrollToSection', section)
    },
  },

  mounted() {
  },
});
</script>


<style lang="scss" scoped>
.footer .payment-methods-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  .image-wrapper {
    /* background-color: white; */
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    max-width: 70px;
  }

  .support-icon.img {
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
}
</style>